import React from 'react';

function Blog(){
    return(
        <div className='blog-class-container'>
            <h2>This is my blog post !</h2>
            <p>Today I started the beginning of the blogpost!</p>
        </div>
    );
}

export default Blog;